import type { LoaderFunction } from 'react-router';
import Maybe from 'true-myth/maybe';
import { fromResult } from 'true-myth/toolbelt';

import type { FetchAlignmentRecord } from '../../position-management/fetch-alignment-record';
import type { AlignmentRecordDetails } from './alignment-record-schema';
import { getAlignmentRecordPathParamsSchema } from './alignment-record-schema';

export type AlignmentRecordPageLoaderData = Maybe<AlignmentRecordDetails>;

export const createAlignmentRecordPageLoader = (fetchAlignmentRecord: FetchAlignmentRecord): LoaderFunction => {
    return async (loaderArguments) => {
        const pathParamsResult = getAlignmentRecordPathParamsSchema.safeParse(loaderArguments.params);

        if (!pathParamsResult.success) {
            return Maybe.nothing();
        }

        const { id, userId } = pathParamsResult.data;

        const alignmentRecordResult = await fetchAlignmentRecord({
            alignmentRecordId: id,
            employeeId: userId,
        });

        return fromResult(alignmentRecordResult);
    };
};
